export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SELECT_AVATAR = 'SELECT_AVATAR';

export const login = payload => {
    return {
        type: USER_LOGIN,
        payload: {
            ...payload,
            token: true,
        },
    };
};

export const logout = () => {
    return {
        type: USER_LOGOUT,
    };
};

export const selectAvatar = avatarIndex => {
    return {
        type: SELECT_AVATAR,
        payload: {
            avatarIndex,
        },
    };
};
